import { render, staticRenderFns } from "./SocialButtons.vue?vue&type=template&id=7088a11d&scoped=true"
import script from "./SocialButtons.vue?vue&type=script&lang=js"
export * from "./SocialButtons.vue?vue&type=script&lang=js"
import style0 from "./SocialButtons.vue?vue&type=style&index=0&id=7088a11d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7088a11d",
  null
  
)

export default component.exports